export var PHOTO_UPLOAD_ALERT = {
    success: 'Patient photo has been uploaded successfully.',
    error: 'Error uploading patient photo. Please try again.',
};
export var PHOTO_REQUIREMENT_ERROR = 'The image could not be uploaded. Please check requirements and try again.';
export var NOTE_TYPES_ERROR = 'Note types have failed to load due to an unknown error.';
export var GENERAL_ERROR = 'Page failed to load due to an unknown error.';
export var CACHED_DATA_MESSAGE;
(function (CACHED_DATA_MESSAGE) {
    CACHED_DATA_MESSAGE["NO_DATE"] = "Trouble connecting to service. Content may be outdated.";
    CACHED_DATA_MESSAGE["WITH_DATE"] = "Data as of ";
    CACHED_DATA_MESSAGE["WITH_DATE_SUFFIX"] = ". Click refresh for the latest.";
})(CACHED_DATA_MESSAGE || (CACHED_DATA_MESSAGE = {}));
